import Button from './Button.vue'

/** 组件名称 */
const COMPONENT_NAME = 'OlaButton'

/**
 * 安装函数
 * @param {import('vue').App} app - Vue 应用实例
 */
Button.install = (app) => {
    app.component(COMPONENT_NAME, Button)
}

export default Button 